 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Aboutus~EidtInformation~NewInformation~Newrecruitment~article~edgepower":"Aboutus~EidtInformation~NewInformation~Newrecruitment~article~edgepower","Aboutus~Newrecruitment~edgepower":"Aboutus~Newrecruitment~edgepower","Aboutus":"Aboutus","edgepower":"edgepower","Complaintsandsuggestions~EidtInformation~Enterprise~NewInformation~makerecruitment":"Complaintsandsuggestions~EidtInformation~Enterprise~NewInformation~makerecruitment","EidtInformation~NewInformation~Newrecruitment":"EidtInformation~NewInformation~Newrecruitment","EidtInformation~NewInformation":"EidtInformation~NewInformation","EidtInformation":"EidtInformation","NewInformation":"NewInformation","Newrecruitment":"Newrecruitment","article":"article","Afterlanding":"Afterlanding","Backupmonitoring":"Backupmonitoring","BestAfterlanding":"BestAfterlanding","Businessunit":"Businessunit","Complaintsandsuggestions":"Complaintsandsuggestions","Enterprise":"Enterprise","makerecruitment":"makerecruitment","Contentmanagement":"Contentmanagement","Customerlist":"Customerlist","DalCompBanner":"DalCompBanner","Digitalcapitalization~Privatetrafficconstruction":"Digitalcapitalization~Privatetrafficconstruction","Digitalcapitalization":"Digitalcapitalization","Privatetrafficconstruction":"Privatetrafficconstruction","Globalresources":"Globalresources","Index":"Index","Information":"Information","Integratedbusinessdevelopmentplatform":"Integratedbusinessdevelopmentplatform","Logmonitoring":"Logmonitoring","Newscenter":"Newscenter","Physicalresourcemonitoring":"Physicalresourcemonitoring","Productmanagercommunicationproject":"Productmanagercommunicationproject","Productmanageroperationproject":"Productmanageroperationproject","Productsinoperation":"Productsinoperation","Productsunderdevelopment":"Productsunderdevelopment","Projectlist":"Projectlist","Resourcedetails":"Resourcedetails","UIdesignproject":"UIdesignproject","UIdevelopmentproject":"UIdevelopmentproject","Unitsubmissionmonitoring":"Unitsubmissionmonitoring","channelmanagement":"channelmanagement","comment":"comment","dal-footer":"dal-footer","dal-header":"dal-header","dal-headfloat-on-menu":"dal-headfloat-on-menu","dal-menu-on-main":"dal-menu-on-main","float":"float","productmanager":"productmanager","question":"question","recruitment":"recruitment","sale":"sale"}[chunkId]||chunkId) + "." + {"Aboutus~EidtInformation~NewInformation~Newrecruitment~article~edgepower":"bd5e62bf","Aboutus~Newrecruitment~edgepower":"4a1e05f0","Aboutus":"34ce9886","edgepower":"3c286361","Complaintsandsuggestions~EidtInformation~Enterprise~NewInformation~makerecruitment":"44d75c1d","EidtInformation~NewInformation~Newrecruitment":"9694cdc1","EidtInformation~NewInformation":"9d3adb47","EidtInformation":"781f5d54","NewInformation":"aee7536d","Newrecruitment":"c9f32cf6","article":"eef294f0","Afterlanding":"3c9e747c","Backupmonitoring":"e63a96a2","BestAfterlanding":"05b001e8","Businessunit":"2761ab6e","Complaintsandsuggestions":"01356467","Enterprise":"d3d4849a","makerecruitment":"be186d87","Contentmanagement":"1dea0fd8","Customerlist":"3408aef1","DalCompBanner":"476c3fcf","Digitalcapitalization~Privatetrafficconstruction":"638a58a1","Digitalcapitalization":"50f530e2","Privatetrafficconstruction":"45fb849d","Globalresources":"e960a430","Index":"ca3ff64b","Information":"c1584211","Integratedbusinessdevelopmentplatform":"6f2ce774","Logmonitoring":"051bd3a3","Newscenter":"4ccbda80","Physicalresourcemonitoring":"56b919bf","Productmanagercommunicationproject":"c2d14f76","Productmanageroperationproject":"9248903d","Productsinoperation":"6eccd830","Productsunderdevelopment":"383f2d6a","Projectlist":"82fbd7f4","Resourcedetails":"8e17b6ca","UIdesignproject":"80ebaf8f","UIdevelopmentproject":"b075b4aa","Unitsubmissionmonitoring":"97d2b4d3","channelmanagement":"b0562f76","chunk-40315fed":"5f341d22","comment":"97710686","dal-footer":"0c8f3564","dal-header":"571ac5c3","dal-headfloat-on-menu":"64c8dd31","dal-menu-on-main":"99dfe67a","float":"70348ea0","productmanager":"6d2040d4","question":"43a23ba7","recruitment":"7e746d45","sale":"24ba9b6c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Aboutus~EidtInformation~NewInformation~Newrecruitment~article~edgepower":1,"Aboutus":1,"edgepower":1,"EidtInformation":1,"NewInformation":1,"Newrecruitment":1,"article":1,"Afterlanding":1,"Backupmonitoring":1,"BestAfterlanding":1,"Businessunit":1,"Complaintsandsuggestions":1,"Enterprise":1,"makerecruitment":1,"Contentmanagement":1,"Customerlist":1,"DalCompBanner":1,"Digitalcapitalization~Privatetrafficconstruction":1,"Digitalcapitalization":1,"Privatetrafficconstruction":1,"Globalresources":1,"Index":1,"Information":1,"Integratedbusinessdevelopmentplatform":1,"Logmonitoring":1,"Newscenter":1,"Physicalresourcemonitoring":1,"Productmanagercommunicationproject":1,"Productmanageroperationproject":1,"Productsinoperation":1,"Productsunderdevelopment":1,"Projectlist":1,"Resourcedetails":1,"UIdesignproject":1,"UIdevelopmentproject":1,"Unitsubmissionmonitoring":1,"channelmanagement":1,"chunk-40315fed":1,"comment":1,"dal-footer":1,"dal-header":1,"dal-headfloat-on-menu":1,"dal-menu-on-main":1,"float":1,"productmanager":1,"question":1,"recruitment":1,"sale":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Aboutus~EidtInformation~NewInformation~Newrecruitment~article~edgepower":"Aboutus~EidtInformation~NewInformation~Newrecruitment~article~edgepower","Aboutus~Newrecruitment~edgepower":"Aboutus~Newrecruitment~edgepower","Aboutus":"Aboutus","edgepower":"edgepower","Complaintsandsuggestions~EidtInformation~Enterprise~NewInformation~makerecruitment":"Complaintsandsuggestions~EidtInformation~Enterprise~NewInformation~makerecruitment","EidtInformation~NewInformation~Newrecruitment":"EidtInformation~NewInformation~Newrecruitment","EidtInformation~NewInformation":"EidtInformation~NewInformation","EidtInformation":"EidtInformation","NewInformation":"NewInformation","Newrecruitment":"Newrecruitment","article":"article","Afterlanding":"Afterlanding","Backupmonitoring":"Backupmonitoring","BestAfterlanding":"BestAfterlanding","Businessunit":"Businessunit","Complaintsandsuggestions":"Complaintsandsuggestions","Enterprise":"Enterprise","makerecruitment":"makerecruitment","Contentmanagement":"Contentmanagement","Customerlist":"Customerlist","DalCompBanner":"DalCompBanner","Digitalcapitalization~Privatetrafficconstruction":"Digitalcapitalization~Privatetrafficconstruction","Digitalcapitalization":"Digitalcapitalization","Privatetrafficconstruction":"Privatetrafficconstruction","Globalresources":"Globalresources","Index":"Index","Information":"Information","Integratedbusinessdevelopmentplatform":"Integratedbusinessdevelopmentplatform","Logmonitoring":"Logmonitoring","Newscenter":"Newscenter","Physicalresourcemonitoring":"Physicalresourcemonitoring","Productmanagercommunicationproject":"Productmanagercommunicationproject","Productmanageroperationproject":"Productmanageroperationproject","Productsinoperation":"Productsinoperation","Productsunderdevelopment":"Productsunderdevelopment","Projectlist":"Projectlist","Resourcedetails":"Resourcedetails","UIdesignproject":"UIdesignproject","UIdevelopmentproject":"UIdevelopmentproject","Unitsubmissionmonitoring":"Unitsubmissionmonitoring","channelmanagement":"channelmanagement","comment":"comment","dal-footer":"dal-footer","dal-header":"dal-header","dal-headfloat-on-menu":"dal-headfloat-on-menu","dal-menu-on-main":"dal-menu-on-main","float":"float","productmanager":"productmanager","question":"question","recruitment":"recruitment","sale":"sale"}[chunkId]||chunkId) + "." + {"Aboutus~EidtInformation~NewInformation~Newrecruitment~article~edgepower":"59e38391","Aboutus~Newrecruitment~edgepower":"31d6cfe0","Aboutus":"5888c472","edgepower":"6614699e","Complaintsandsuggestions~EidtInformation~Enterprise~NewInformation~makerecruitment":"31d6cfe0","EidtInformation~NewInformation~Newrecruitment":"31d6cfe0","EidtInformation~NewInformation":"31d6cfe0","EidtInformation":"d9b58d14","NewInformation":"e665fa7b","Newrecruitment":"1e04bec3","article":"2e4d4fe9","Afterlanding":"630c5dcc","Backupmonitoring":"bb672593","BestAfterlanding":"7b26939a","Businessunit":"56c09846","Complaintsandsuggestions":"ca219a50","Enterprise":"40c1a6b3","makerecruitment":"419d347f","Contentmanagement":"83ee1235","Customerlist":"29ff6a50","DalCompBanner":"2df7e21b","Digitalcapitalization~Privatetrafficconstruction":"22920f3f","Digitalcapitalization":"9f49a6da","Privatetrafficconstruction":"7dfeb487","Globalresources":"ccc238b1","Index":"b8df65d1","Information":"c4f1b26f","Integratedbusinessdevelopmentplatform":"c406eb5e","Logmonitoring":"e61d0f58","Newscenter":"99ed482a","Physicalresourcemonitoring":"e13222cf","Productmanagercommunicationproject":"37d09fcb","Productmanageroperationproject":"4662158d","Productsinoperation":"545ab237","Productsunderdevelopment":"e29fa0d0","Projectlist":"5acc8b90","Resourcedetails":"bb331a6e","UIdesignproject":"450abe89","UIdevelopmentproject":"69f70f74","Unitsubmissionmonitoring":"ce3a0890","channelmanagement":"3301e235","chunk-40315fed":"a6d516a5","comment":"c4c0f2d1","dal-footer":"06558369","dal-header":"3b50ed23","dal-headfloat-on-menu":"49f8bf8a","dal-menu-on-main":"44dd57e3","float":"0d693168","productmanager":"f89451d7","question":"07454872","recruitment":"5cdba282","sale":"1c2b5b8c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
